import { format, formatDistanceToNowStrict, parseISO } from "date-fns";

export function formatNumber(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  if (Math.abs(value) >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(value >= 10_000_000 ? 0 : 1)}M`;
  }
  if (Math.abs(value) >= 1_000) {
    return `${(value / 1_000).toFixed(value >= 10_000 ? 0 : 1)}k`;
  }
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatNumberFull(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  return new Intl.NumberFormat("en-US").format(value);
}

export function formatPercent(
  rateZeroToOne: number | null | undefined,
  fractionDigits = 1
): string {
  if (rateZeroToOne == null || Number.isNaN(rateZeroToOne)) return "—";
  return `${(rateZeroToOne * 100).toFixed(fractionDigits)}%`;
}

export function formatPercentage(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return "—";
  return value.toFixed(2);
}

export function formatReportDate(value: string | null | undefined): string {
  if (!value) return "—";
  // value is "YYYY-MM-DD" — parse as local to avoid TZ shift
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return value;
  const date = new Date(year, month - 1, day);
  return format(date, "MMM d, yyyy");
}

export function formatReportDateShort(value: string | null | undefined): string {
  if (!value) return "—";
  const [year, month, day] = value.split("-").map(Number);
  if (!year || !month || !day) return value;
  const date = new Date(year, month - 1, day);
  return format(date, "MMM d");
}

export function formatTimestamp(value: string | null | undefined): string {
  if (!value) return "—";
  try {
    return format(parseISO(value), "MMM d, yyyy h:mm a");
  } catch {
    return value;
  }
}

export function formatRelative(value: string | null | undefined): string {
  if (!value) return "—";
  try {
    return `${formatDistanceToNowStrict(parseISO(value))} ago`;
  } catch {
    return "—";
  }
}

export function xPostUrl(xPostId: string): string {
  return `https://x.com/i/web/status/${xPostId}`;
}
